import React, { useState } from 'react';
import { Button } from 'react-bootstrap';

import {
  CreateUpdateProfileCategoryDto,
  CreateUpdateProfileCategoryYearDto,
} from '../../../common/pokCore/autogenerated/pokApiClient';
import { newProfileCategoryYear } from '../../../common/pokCore/contexts/ProfileCategoryContext';
import { useTranslation } from '../../../common/hooks/useTranslation';

import { ProfileCategoryYearModalEditor } from './ProfileCategoryYearModalEditor';
import { ProfileCategoryEditorFormYearsGrid } from './ProfileCategoryEditorFormYearsGrid';

interface ProfileCategoryEditorFormYearsProps {
  profileCategory: CreateUpdateProfileCategoryDto;
  propertyChange: (obj: Partial<CreateUpdateProfileCategoryDto>) => void;
  readOnly?: boolean;
}

export const ProfileCategoryEditorFormYears: React.FC<
  ProfileCategoryEditorFormYearsProps
> = props => {
  const { t, tk } = useTranslation('administrationLng');

  const [itemId, setItemId] = useState<string>();
  const [PCYear, setPCYear] = useState<
    CreateUpdateProfileCategoryYearDto | undefined
  >();
  const [show, setShow] = useState(false);

  const handleClick = async (id: string) => {
    const PCYear = props.profileCategory.profileCategoriesYears?.find(
      (year, index) => index.toString() === id,
    );
    setItemId(id);
    setPCYear(PCYear);
    setShow(true);
  };

  const handleAdd = () => {
    setShow(true);
    setPCYear(undefined);
  };

  const handleClose = () => {
    setShow(false);
    setPCYear(undefined);
    setItemId(undefined);
  };

  const handleSave = (
    profileCategoryYearCU: CreateUpdateProfileCategoryYearDto,
    id?: string,
  ) => {
    let years = props.profileCategory.profileCategoriesYears || [];
    if (id) {
      years = years.map((year, index) => {
        if (index.toString() === id) {
          return { ...profileCategoryYearCU };
        }
        return year;
      });
    } else {
      years = [...years, profileCategoryYearCU];
    }
    props.propertyChange({ profileCategoriesYears: years });
    handleClose();
  };

  return (
    <>
      {props.readOnly ? null : (
        <Button variant="outline-primary" className="mb-4" onClick={handleAdd}>
          {t(tk.administration.profileCategoryYearNew)}
        </Button>
      )}
      <ProfileCategoryEditorFormYearsGrid
        profileCategory={props.profileCategory}
        onRowClick={props.readOnly ? undefined : handleClick}
      />
      {show && (
        <ProfileCategoryYearModalEditor
          id={itemId}
          profileCategoryYear={PCYear || newProfileCategoryYear()}
          handleClose={handleClose}
          show={show}
          onCompleted={handleSave}
        />
      )}
    </>
  );
};
